import { Api } from 'src/common';
import { getMerchantId, getUserId } from './user.service';

type PrivateKey = {
  id: string;
  authKey: string;
  restrictedUrl: string | null;
  merchantId: string;
  name: string;
  privateKye: string;
  dateCreated: string;
  disabled: boolean;
};

type PrivateKeyResponse = {
  ok: boolean;
  result?: PrivateKey;
  message?: string;
};

export async function getMerchantPrivateKey(
  abortController: AbortController,
): Promise<PrivateKeyResponse> {
  const userId = getUserId();
  const merchantNumber = getMerchantId();
  const endpoint = `merchant/privatekey?userReference=${userId}&merchantNumber=${merchantNumber}`;

  try {
    const result = await Api.get<PrivateKeyResponse>(endpoint, {
      signal: abortController?.signal || null,
    });

    if (result && result.response && result.response?.result && result.status === 200) {
      return {
        ok: true,
        result: result.response?.result[0],
      };
    }

    if (result.status > 500) {
      throw new Error(
        `Get Merchant Private Key: Invalid response: ${result.status}: ${JSON.stringify(
          result.response,
        )}`,
      );
    }
  } catch (error) {
    return { ok: false, message: error as string };
  }
  return { ok: false };
}
